import {
  FieldTypeFactory,
  ComponentTypeFactory,
} from '@sentecacommerce-theme/base'
import { DefaultConfig } from '@sentecacommerce-theme/lib'

export const ConfigType = ComponentTypeFactory.create<DefaultConfig>('Config', {
  apiUrl: FieldTypeFactory.text(),
  organizationPhone: FieldTypeFactory.text(),

  price: {
    locale: FieldTypeFactory.text(),
  },
  domain: FieldTypeFactory.text(),
  defaultMerchant: FieldTypeFactory.text(),

  favicon: {
    svg: FieldTypeFactory.image(),
    default: FieldTypeFactory.image(),
    medium: FieldTypeFactory.image(),
  },

  theme: {
    palette: {
      primary: FieldTypeFactory.text(),
      secondary: FieldTypeFactory.text(),
      hint: FieldTypeFactory.text(),
      disabled: FieldTypeFactory.text(),
      grey: FieldTypeFactory.text(),
      danger: FieldTypeFactory.text(),
      greyTitle: FieldTypeFactory.text(),
      yellow: FieldTypeFactory.text(),
      white: FieldTypeFactory.text(),
      discounted: FieldTypeFactory.text(),

      seaGreen: FieldTypeFactory.text(),
      panache: FieldTypeFactory.text(),
      surfCrest: FieldTypeFactory.text(),
      dark: FieldTypeFactory.text(),
      lightgrey: FieldTypeFactory.text(),
      lightergrey: FieldTypeFactory.text(),
      initialPrice: FieldTypeFactory.text(),
      silverTree: FieldTypeFactory.text(),
      burntSienna: FieldTypeFactory.text(),
      salmon: FieldTypeFactory.text(),
      whisper: FieldTypeFactory.text(),
    },
    breakpoints: {
      xs: {
        min: FieldTypeFactory.text(),
        max: FieldTypeFactory.text(),
      },
      sm: {
        min: FieldTypeFactory.text(),
        max: FieldTypeFactory.text(),
      },
      md: {
        min: FieldTypeFactory.text(),
        max: FieldTypeFactory.text(),
      },
      lg: {
        min: FieldTypeFactory.text(),
        max: FieldTypeFactory.text(),
      },
      xl: {
        min: FieldTypeFactory.text(),
        max: FieldTypeFactory.text(),
      },
      xxl: {
        min: FieldTypeFactory.text(),
      },
    },
    containers: {
      xs: FieldTypeFactory.text(),
      sm: FieldTypeFactory.text(),
      md: FieldTypeFactory.text(),
      lg: FieldTypeFactory.text(),
      xl: FieldTypeFactory.text(),
      xxl: FieldTypeFactory.text(),
    },
    spacingBaseUnit: FieldTypeFactory.number(),
    elementsBorderRadius: FieldTypeFactory.number(),
    typography: {
      fontFamily: FieldTypeFactory.list({ of: FieldTypeFactory.text() }),
    },
  },
  palette: {
    primary: FieldTypeFactory.text(),
    secondary: FieldTypeFactory.text(),
    hint: FieldTypeFactory.text(),
    disabled: FieldTypeFactory.text(),
    grey: FieldTypeFactory.text(),
    danger: FieldTypeFactory.text(),
    greyTitle: FieldTypeFactory.text(),
    yellow: FieldTypeFactory.text(),
    white: FieldTypeFactory.text(),
    discounted: FieldTypeFactory.text(),

    seaGreen: FieldTypeFactory.text(),
    panache: FieldTypeFactory.text(),
    surfCrest: FieldTypeFactory.text(),
    dark: FieldTypeFactory.text(),
    lightgrey: FieldTypeFactory.text(),
    lightergrey: FieldTypeFactory.text(),
    initialPrice: FieldTypeFactory.text(),
    silverTree: FieldTypeFactory.text(),
    burntSienna: FieldTypeFactory.text(),
    salmon: FieldTypeFactory.text(),
    whisper: FieldTypeFactory.text(),
  },
  imagesConfig: {
    ratio: {
      width: FieldTypeFactory.number(),
      height: FieldTypeFactory.number(),
    },
    fallbackImage: FieldTypeFactory.image(),
  },
  breakpoints: {
    xs: {
      min: FieldTypeFactory.text(),
      max: FieldTypeFactory.text(),
    },
    sm: {
      min: FieldTypeFactory.text(),
      max: FieldTypeFactory.text(),
    },
    md: {
      min: FieldTypeFactory.text(),
      max: FieldTypeFactory.text(),
    },
    lg: {
      min: FieldTypeFactory.text(),
      max: FieldTypeFactory.text(),
    },
    xl: {
      min: FieldTypeFactory.text(),
      max: FieldTypeFactory.text(),
    },
    xxl: {
      min: FieldTypeFactory.text(),
    },
  },
  containers: {
    xs: FieldTypeFactory.text(),
    sm: FieldTypeFactory.text(),
    md: FieldTypeFactory.text(),
    lg: FieldTypeFactory.text(),
    xl: FieldTypeFactory.text(),
    xxl: FieldTypeFactory.text(),
  },
  spacingBaseUnit: FieldTypeFactory.number(),
  elementsBorderRadius: FieldTypeFactory.number(),
  typography: {
    fontFamily: FieldTypeFactory.list({ of: FieldTypeFactory.text() }),
  },
  countryCode: FieldTypeFactory.text(),

  facebook: {
    appId: FieldTypeFactory.text(),
  },

  google: {
    id: FieldTypeFactory.text(),

    reMarketing: {
      id: FieldTypeFactory.text(),
      label: FieldTypeFactory.text(),
    },
  },

  freeShippingPrice: FieldTypeFactory.number(),
  attributeKeys: {
    size: FieldTypeFactory.text(),
    color: FieldTypeFactory.text(),
  },
  customFieldKeys: {
    isWithFixedDelivery: FieldTypeFactory.text(),
    isOnlyInPhysicalStores: FieldTypeFactory.text(),
    isNew: FieldTypeFactory.text(),
    isWithVideo: FieldTypeFactory.text(),
    isAction: FieldTypeFactory.text(),
    isOnlyInHippoland: FieldTypeFactory.text(),
    isOnlineOnly: FieldTypeFactory.text(),
    isWithTopPrice: FieldTypeFactory.text(),
    newFromDate: FieldTypeFactory.text(),
    newToDate: FieldTypeFactory.text(),
    hasVideo: FieldTypeFactory.text(),
    hideRegularPrice: FieldTypeFactory.text(),
    hidePromoLabel: FieldTypeFactory.text(),
    video: FieldTypeFactory.text(),
    discountIcon: FieldTypeFactory.text(),
  },
  wallets: {
    hippoWallet: FieldTypeFactory.text(),
  },
  inventory: {
    maxQuantity: FieldTypeFactory.number(),
  },
  affiliates: {
    twoPerformant: {
      campaignUnique: FieldTypeFactory.text(),
      confirm: FieldTypeFactory.text(),
    },
  },
  analytics: {
    facebookPixel: FieldTypeFactory.text(),
    googleAds: FieldTypeFactory.text(),
    googleAnalytics: FieldTypeFactory.text(),
    googleTagManager: FieldTypeFactory.text(),
  },
  views: {
    auth: FieldTypeFactory.text(),
    gdprModal: FieldTypeFactory.text(),
    checkoutBasketPreview: FieldTypeFactory.text(),
    addressForm: FieldTypeFactory.text(),
  },
  courierKeys: {
    econt: FieldTypeFactory.text(),
    speedy: FieldTypeFactory.text(),
    evropat: FieldTypeFactory.text(),
  },
  integration: FieldTypeFactory.text(),

  listing: {
    defaultSort: FieldTypeFactory.text(),
    filterExtension: FieldTypeFactory.text(),
  },
  globalLabels: {
    freeDelivery: FieldTypeFactory.text(),
    close: FieldTypeFactory.text(),
    cancel: FieldTypeFactory.text(),
    remove: FieldTypeFactory.text(),
    save: FieldTypeFactory.text(),
    edit: FieldTypeFactory.text(),
    nr: FieldTypeFactory.text(),
    begin: FieldTypeFactory.text(),
    viewAll: FieldTypeFactory.text(),
    productNumber: FieldTypeFactory.text(),
    offerIsValid: FieldTypeFactory.text(),
    sku: FieldTypeFactory.text(),
    qty: FieldTypeFactory.text(),
    onlyInHippoland: FieldTypeFactory.text(),
    onlyOnline: FieldTypeFactory.text(),
    new: FieldTypeFactory.text(),
    bestSeller: FieldTypeFactory.text(),
    notRegistered: FieldTypeFactory.text(),
    continueAsGuest: FieldTypeFactory.text(),
    send: FieldTypeFactory.text(),
    logIn: FieldTypeFactory.text(),
    enter: FieldTypeFactory.text(),
    back: FieldTypeFactory.text(),
    or: FieldTypeFactory.text(),
    basketPreview: FieldTypeFactory.text(),
    addToWishlist: FieldTypeFactory.text(),
    under: FieldTypeFactory.text(),
    over: FieldTypeFactory.text(),
    bgn: FieldTypeFactory.text(),
    delivery: FieldTypeFactory.text(),
    total: FieldTypeFactory.text(),
    apply: FieldTypeFactory.text(),
    show: FieldTypeFactory.text(),
    continueWithShopping: FieldTypeFactory.text(),
    availableOnlyInPhysicalStores: FieldTypeFactory.text(),
    gender: {
      male: FieldTypeFactory.text(),
      female: FieldTypeFactory.text(),
    },
    pagination: {
      prevPage: FieldTypeFactory.text(),
      nextPage: FieldTypeFactory.text(),
    },
    signs: {
      minus: FieldTypeFactory.text(),
      percent: FieldTypeFactory.text(),
      hashTag: FieldTypeFactory.text(),
      lessThan: FieldTypeFactory.text(),
    },
    socialLogins: {
      facebook: FieldTypeFactory.text(),
      google: FieldTypeFactory.text(),
    },
    register: {
      label: FieldTypeFactory.text(),
      callToAction: FieldTypeFactory.text(),
    },
    emailAddress: FieldTypeFactory.text(),
    placeholders: {
      day: FieldTypeFactory.text(),
      month: FieldTypeFactory.text(),
      year: FieldTypeFactory.text(),
      email: FieldTypeFactory.text(),
      choose: FieldTypeFactory.text(),
      chooseStore: FieldTypeFactory.text(),
      newPassword: FieldTypeFactory.text(),
    },
    password: {
      label: FieldTypeFactory.text(),
      forgottenPassword: FieldTypeFactory.text(),
      changePassPrompt: {
        initial: FieldTypeFactory.text(),
        final: FieldTypeFactory.text(),
      },
      backToLogIn: FieldTypeFactory.text(),
      orReturnTo: FieldTypeFactory.text(),
      reEnterPassword: FieldTypeFactory.text(),
      changePassword: FieldTypeFactory.text(),
      pleaseEnterNewPassword: FieldTypeFactory.text(),
    },
    toastNotifications: {
      success: {
        subscribe: FieldTypeFactory.text(),
        unsubscribe: FieldTypeFactory.text(),
      },
    },
    buttonLabels: {
      ariaLabel: FieldTypeFactory.text(),
      alreadyInBasket: FieldTypeFactory.text(),
      add: FieldTypeFactory.text(),
    },
    errorMessages: {
      outOfStock: FieldTypeFactory.text(),
      notEnoughQty: FieldTypeFactory.text(),
      outOfStockBasket: FieldTypeFactory.text(),
      notAvailable: FieldTypeFactory.text(),
      somethingWentWrong: FieldTypeFactory.text(),
      noResultsFound: FieldTypeFactory.text(),
      invalidCredentials: FieldTypeFactory.text(),
      emailIsAlreadyInUse: FieldTypeFactory.text(),
      pleaseSelectAnOption: FieldTypeFactory.text(),
    },
    company: {
      companyData: FieldTypeFactory.text(),
      companyName: FieldTypeFactory.text(),
      mol: FieldTypeFactory.text(),
      vat: FieldTypeFactory.text(),
      companyId: FieldTypeFactory.text(),
      saveAsDefault: FieldTypeFactory.text(),
    },
    promoCodeLabels: {
      promoCodeBoxTitle: FieldTypeFactory.text(),
      promoCodeDefaultErrorMessage: FieldTypeFactory.text(),
      promoCodeSubmitLabel: FieldTypeFactory.text(),
      promoCodeInputPlaceholder: FieldTypeFactory.text(),
      errorsMap: {
        MaxApplicationReached: FieldTypeFactory.text(),
        NotValid: FieldTypeFactory.text(),
        NotActive: FieldTypeFactory.text(),
        DoesNotMatchCart: FieldTypeFactory.text(),
        ApplicationStoppedByPreviousDiscount: FieldTypeFactory.text(),
      },
    },
    globalValidations: {
      invalidEmail: FieldTypeFactory.text(),
      invalidNumber: FieldTypeFactory.text(),
      invalidPhoneNumber: FieldTypeFactory.text(),
      requiredFields: FieldTypeFactory.text(),
      fieldIsRequired: FieldTypeFactory.text(),
      fillStreetNumberBuildingEntranceOrApartment: FieldTypeFactory.text({
        required: true,
      }),
      streetIsRequired: FieldTypeFactory.text({ required: true }),
      quarterIsRequired: FieldTypeFactory.text({ required: true }),
      emailIsRequired: FieldTypeFactory.text({ required: true }),
      cantFindStreetOrQuarterMessage: FieldTypeFactory.text({
        required: true,
      }),
      cityIsRequired: FieldTypeFactory.text({ required: true }),
      inactiveCard: FieldTypeFactory.text({ required: true }),
      officeIsRequired: FieldTypeFactory.text({ required: true }),
      selectCourier: FieldTypeFactory.text({ required: true }),
      noStoreSelected: FieldTypeFactory.text({ required: true }),
      enterNsymbolsSentence: {
        begin: FieldTypeFactory.text({ required: true }),
        end: FieldTypeFactory.text({ required: true }),
      },
      passwordsDoNotMatch: FieldTypeFactory.text({ required: true }),
      passwordLength: FieldTypeFactory.text({ required: true }),
    },
    personalInformation: {
      label: FieldTypeFactory.text(),
      firstName: FieldTypeFactory.text(),
      lastName: FieldTypeFactory.text(),
      email: FieldTypeFactory.text(),
      number: FieldTypeFactory.text(),
    },
    couriers: {
      pickACourier: FieldTypeFactory.text(),
      couriersList: {
        econtAddress: FieldTypeFactory.text(),
        speedyAddress: FieldTypeFactory.text(),
        evropatAddress: FieldTypeFactory.text(),

        econtOffice: FieldTypeFactory.text(),
        speedyOffice: FieldTypeFactory.text(),
        evropatOffice: FieldTypeFactory.text(),
      },
    },
    address: {
      label: FieldTypeFactory.text(),
      city: FieldTypeFactory.text(),
      quarter: FieldTypeFactory.text(),
      street: FieldTypeFactory.text(),
      streetNumber: FieldTypeFactory.text(),
      number: FieldTypeFactory.text(),
      postalCode: FieldTypeFactory.text(),
      entrance: FieldTypeFactory.text(),
      building: FieldTypeFactory.text(),
      floor: FieldTypeFactory.text(),
      et: FieldTypeFactory.text(),
      vh: FieldTypeFactory.text(),
      ap: FieldTypeFactory.text(),
      ul: FieldTypeFactory.text(),
      apartment: FieldTypeFactory.text(),
      additionalInformation: FieldTypeFactory.text(),
      addNewAddress: FieldTypeFactory.text(),
      noSavedAddresses: FieldTypeFactory.text(),
      addAddressWarning: FieldTypeFactory.text(),
      mainAddress: FieldTypeFactory.text(),
      office: FieldTypeFactory.text(),
      courier: FieldTypeFactory.text(),
    },
  },
  SSR: {
    staticPagesRevalidateTime: FieldTypeFactory.number({
      meta: {
        description: 'Value in seconds',
      },
    }),
    blogRevalidateTime: FieldTypeFactory.number({
      meta: {
        description: 'Value in seconds',
      },
    }),
    productRevalidateTime: FieldTypeFactory.number({
      meta: {
        description: 'Value in seconds',
      },
    }),
  },
})
